import { BotConfiguration } from '@feedyou/schema'

export const isInDeleteMode = (config: BotConfiguration) => !!config?.softDeletedAtTimestamp
export const isInArchiveMode = (config: BotConfiguration) => !!config?.archivedAtTimestamp
